import React, { useState } from "react";
import CoinCard from "../../components/CoinCard";
import walletObjects from "../../data/walletdata";
import WalletBarcode from "../../components/WalletBarcode";
import Withdraw from "./Withdraw";

function Wallet() {
  const [showWithdrawModal, setShowWithdrawModal] = useState(false);
  const [showDepositModal, setShowDepositModal] = useState(false);

  const onDepositClick = () => {
    setShowDepositModal(true);
  };

  const onWithdrawClick = () => {
    setShowWithdrawModal(true);
  };

  return (
    <>
      <div className="md:px-[72px] h-screen   py-[20px] md:py-[62px] flex flex-col gap-[50px] px-[33px]  mt-[16px] md:w-[70vw] w-full md:mx-0 mx-auto bg-[#FCFCF6] ">
        {walletObjects.map((object) => {
          return (
            <CoinCard
              name={object.name}
              icon={object.icon}
              price={object.price}
              inDollar={object.inDollar}
              onDepositClick={onDepositClick}
              onWithdrawClick={onWithdrawClick}
            />
          );
        })}
      </div>
      {showDepositModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => {
              setShowDepositModal(false);
            }}
          ></div>
          <div className="bg-red-500">
            <div className="flex items-center justify-center">
              <WalletBarcode />
            </div>
          </div>
        </div>
      )}

      {showWithdrawModal && (
        <div className="fixed inset-0 flex items-center justify-center z-20 ">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => {
              setShowWithdrawModal(false);
            }}
          ></div>
          <div className="bg-red-500 z-40">
            <div className="flex items-center justify-center">
              <Withdraw />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Wallet;
